import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,

  wrapperSoonProductsGrid: {
    background: "#fff",
    borderRadius: "107px 107px 0px 0px",
    borderTop: "3px solid #000",
    borderLeft: "3px solid #000",
    borderRight: "3px solid #000",
    //
    width: "100vw",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    //
    //
    // *** MEDIA  querie
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "yellow",
      borderRadius: "107px 107px 146px 146px",
      borderBottom: "9px solid #121212",
    },
    [theme.breakpoints.up("sm")]: {
      borderRadius: "107px 107px 146px 146px",
    },

    [theme.breakpoints.up("md")]: {
      borderRadius: "107px 107px 146px 146px",
    },
    [theme.breakpoints.up("lg")]: {
      borderTop: "9px solid #121212",
      borderRadius: "107px 107px 146px 146px",
    },
  },

  GridContainerProducts: {
    // *** GRID
    gridTemplateColumns: `repeat(4, 1fr)`,
    display: "grid",
    gridGap: "0.5em",
    //
    //
    width: "90%",
    height: "100%",
    padding: "100px 70px 120px 70px",
    //
    background: "rgba(255, 249, 141, 1)", // yellow cards contain
    borderRadius: "107px 107px 0px 0px",
    borderTop: "5px solid #000",
    borderLeft: "5px solid #000",
    borderRight: "5px solid #000",

    //
    // *** MEDIA  querie
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "yellow",
      border: "3px solid #121212",
      background: "rgba(255, 249, 141, 1)",
      width: "100%",
      padding: "60px 5px 120px 5px",
      gridTemplateColumns: `repeat(1, 1fr)`,
      gridGap: "0.1em",
      //
      borderRadius: "107px 107px 146px 146px",
      borderTop: "9px solid #121212",
      borderLeft: "3px solid #121212",
      borderRight: "3px solid #121212",
      borderBottom: "0",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
      background: "rgba(255, 249, 141, 1)",
      width: "100%",
      padding: "100px 10px 120px 10px",
      gridTemplateColumns: `repeat(1, 1fr)`,
      gridGap: "0.1em",
      borderTop: "3px solid #000",
      borderLeft: "3px solid #000",
      borderRight: "3px solid #000",
      //
      borderRadius: "107px 107px 146px 146px",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "green",
      width: "100%",
      padding: "100px 10px 120px 10px",
      gridTemplateColumns: `repeat(2, 1fr)`,
      gridGap: "0.1em",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "purple",
      background: "rgba(255, 249, 141, 1)",
      width: "100%",
      padding: "70px 10px 100px 10px",
      gridTemplateColumns: `repeat(4, 1fr)`,
      gridGap: "0.1em",
      // create another grid for the stories, as this one is linked to them, then add a minHeight 170vh
      borderTop: "5px solid #121212",
    },

    //
    //
  },
}));
